import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: any) => {
  return createStyles({
    root: {
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
    },
    wrapIcon: {
      verticalAlign: "middle",
      display: "inline-flex",
    },
    cursorPointer: {
      cursor: "pointer",
    },
  });
});
